import VueRouter from 'vue-router';
import Vue from 'vue';
import store from '../../js/front/store';

const trans = Vue.prototype.trans;

const title = process.env.MIX_TITLE;

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/mobile/payment',
      component: () => import('./views/pages/RouterView.vue'),
      children: [
        {
          path: '/',
          name: 'mobile-payment',
          component: () => import('./views/pages/Mobile/Payment.vue'),
          meta: {
            layout: 'DefaultLayout',
            title: title,
            profile: false,
          },
          beforeEnter(to, from, next) {
            store.commit('shop/setSelectedPackage', null);

            if (to.hash !== '#b') {
              store.commit('shop/setVoucher', null);
            }

            return next();
          },
        },
        {
          path: ':unit/:packageId',
          name: 'mobile-payment-method',
          component: () => import('./views/pages/Mobile/Payment.vue'),
          meta: {
            layout: 'DefaultLayout',
            title: title,
            profile: false,
          },
          beforeEnter(to, from, next) {
            // Keep the package just selected on the list; clear only on direct
            // / external entry so a stale selection cannot stick to a deep link.
            if (from.name !== 'mobile-payment') {
              store.commit('shop/setSelectedPackage', null);
            }

            return next();
          },
        },
      ],
      beforeEnter(to, from, next) {
        store.commit('settings/setIsMobile', true);
        return next();
      },
    },
    {
      path: '/more-settings/payment/success',
      name: 'payment-success',
      component: () => import('./views/pages/MoreSettings/PaymentSuccess.vue'),
      meta: {
        layout: 'DefaultLayout',
        title: title,
        profile: false,
      },
    },
    {
      path: '/more-settings/payment/failure',
      name: 'payment-failure',
      component: () => import('./views/pages/MoreSettings/PaymentFailure.vue'),
      meta: {
        layout: 'DefaultLayout',
        title: title,
        profile: false,
      },
    },
    {
      path: '/more-settings/payment/abort',
      name: 'payment-abort',
      component: () => import('./views/pages/MoreSettings/PaymentAbort.vue'),
      meta: {
        layout: 'DefaultLayout',
        title: title,
        profile: false,
      },
    },
    {
      path: '/more-settings/payment/return',
      name: 'payment-return',
      component: () => import('./views/pages/MoreSettings/PaymentReturn.vue'),
      meta: {
        layout: 'DefaultLayout',
        title: title,
        profile: false,
      },
    },
    {
      path: '/unsubscribe-email/:token?',
      name: 'unsubscribe-email',
      component: () => import('./views/pages/UnsubscribeEmail.vue'),
      meta: {
        layout: 'DefaultLayout',
        profile: false,
      },
    },
  ],
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    Vue.nextTick(() => {
      document.title = to.meta.title;
    });
  }
});

export default router;
